<script lang="ts">
    import { defineComponent, h } from 'vue';

    // PRODUCT-26110 Task 8b Step 4: vue-country-flag is Vue-2-only; vue-country-flag-next
    // is the same author's Vue 3 fork, a drop-in replacement (identical `country`/`size`/
    // `rounded`/`shadow`/`background` props, same default export name).
    import CountryFlag from 'vue-country-flag-next';

    import CriterionEnumInput from './CriterionEnumInput.vue';

    // PRODUCT-26110 Phase 2B2: this was a Vue 2 `functional: true` component using the
    // legacy `render(createElement, context)` signature (removed in Vue 3 -- functional
    // components are now plain functions, and the render-context/scopedSlots API this
    // relied on no longer exists). Rewritten as a thin non-functional wrapper: it forwards
    // its attrs to CriterionEnumInput unchanged and supplies the same dropdownPrepend
    // slot (rendering a country flag for the currently selected option), which is the
    // Vue 3-idiomatic equivalent of what the old functional render did.
    export default defineComponent({
        name: 'CriterionEnumCountryInput',
        inheritAttrs: false,
        render() {
            return h(
                CriterionEnumInput,
                { ...this.$attrs },
                {
                    dropdownPrepend: (props: { currentOption: { value: string }[] }) => {
                        const currentCountryValue = props.currentOption[0]?.value || '';
                        return h(CountryFlag, { country: currentCountryValue });
                    },
                },
            );
        },
    });
</script>
